import React, { ReactElement, ForwardedRef } from 'react';
import TableCellInternal from '@mui/material/TableCell';
import FormatService from '../../services/format-service';
import useStylesTableCell from './table-cell.styles';

const TableCell: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLTableSectionElement>,
): ReactElement => {
  const {
    isText,
    isTextMultiline,
    isTextLeft,
    isTextRight,
    isTextCenter,
    isTextNormal,
    isTextWrap,
    isTextNoWrap,
    isNumber,
    isActions,
    isActive,
    isActiveText,
    isDark,
    isDisabled,
    isButton,
    isHeader,
    isSticky,
    isStickyLeft,
    isStickyLeftSelect,
    isStickyLeftSelectExtended,
    isStickyLeftHeader,
    isStickyRight,
    isStickyRightHeader,
    isStickyGroupLeft,
    isStickyGroupLeftSelect,
    isStickyGroupRight,
    withNoPadding,
    withNoFixedSize,
    withSmallPadding,
    className,
    width,
    colSpan,
    sortDirection,
    onClick,
    children,
  } = props;

  const stylesProps: MaterialUIStylesProps = {
    width,
  };

  const { classes } = useStylesTableCell(stylesProps);

  const textClassName: string | undefined = isText ? classes.tableCellText : undefined;
  const textMultilineClassName: string | undefined = isTextMultiline ? classes.tableCellTextMultiline : undefined;
  const textLeftClassName: string | undefined = isTextLeft ? classes.tableCellTextLeft : undefined;
  const textRightClassName: string | undefined = isTextRight ? classes.tableCellTextRight : undefined;
  const textCenterClassName: string | undefined = isTextCenter ? classes.tableCellTextCenter : undefined;
  const textNormalClassName: string | undefined = isTextNormal ? classes.tableCellTextNormal : undefined;
  const textNoWrapClassName: string | undefined = isTextNoWrap ? classes.tableCellTextNoWrap : undefined;
  const textWrapClassName: string | undefined = isTextWrap ? classes.tableCellTextWrap : undefined;
  const numberClassName: string | undefined = isNumber ? classes.tableCellNumber : undefined;
  const headerClassName: string | undefined = isHeader ? classes.tableCellHeader : undefined;
  const actionsClassName: string | undefined = isActions ? classes.tableCellActions : undefined;
  const disabledClassName: string | undefined = isDisabled ? classes.tableCellDisabled : undefined;
  const buttonClassName: string | undefined = isButton ? classes.tableCellButton : undefined;
  const noPaddingClassName: string | undefined = withNoPadding ? classes.tableCellNoPadding : undefined;
  const noFixedSizeClassName: string | undefined = withNoFixedSize ? classes.tableCellNoFixedSize : undefined;
  const smallPaddingClassName: string | undefined = withSmallPadding ? classes.tableCellSmallPadding : undefined;
  const activeClassName: string | undefined = isActive ? classes.tableCellActive : undefined;
  const activeTextClassName: string | undefined = isActiveText ? classes.tableCellActiveText : undefined;
  const darkClassName: string | undefined = isDark ? classes.tableCellDark : undefined;
  const stickyClassName: string | undefined = isSticky ? classes.tableCellSticky : undefined;
  const stickyLeftClassName: string | undefined = isStickyLeft ? classes.tableCellStickyLeft : undefined;
  const stickyLeftSelectClassName: string | undefined = isStickyLeftSelect
    ? classes.tableCellStickyLeftSelect : undefined;
  const stickyLeftSelectExtendedClassName: string | undefined = isStickyLeftSelectExtended
    ? classes.tableCellStickyLeftSelectExtended : undefined;
  const stickyLeftHeaderClassName: string | undefined = isStickyLeftHeader
    ? classes.tableCellStickyLeftHeader : undefined;
  const stickyGroupLeftClassName: string | undefined = isStickyGroupLeft
    ? classes.tableCellStickyGroupLeft : undefined;
  const stickyGroupLeftSelectClassName: string | undefined = isStickyGroupLeftSelect
    ? classes.tableCellStickyGroupLeftSelect : undefined;
  const stickyRightClassName: string | undefined = isStickyRight ? classes.tableCellStickyRight : undefined;
  const stickyRightHeaderClassName: string | undefined = isStickyRightHeader
    ? classes.tableCellStickyRightHeader : undefined;
  const stickyGroupRightClassName: string | undefined = isStickyGroupRight
    ? classes.tableCellStickyGroupRight : undefined;

  return (
    <TableCellInternal
      ref={ref}
      className={FormatService.formatClassNames(
        classes.tableCell, textClassName, textMultilineClassName,
        textLeftClassName, textRightClassName, textCenterClassName,
        textNormalClassName, textNoWrapClassName, textWrapClassName, numberClassName, headerClassName, actionsClassName,
        disabledClassName, buttonClassName, noPaddingClassName, noFixedSizeClassName, smallPaddingClassName,
        activeClassName, activeTextClassName, darkClassName,
        stickyClassName, stickyLeftClassName, stickyLeftSelectClassName, stickyLeftSelectExtendedClassName,
        stickyLeftHeaderClassName, stickyGroupLeftClassName, stickyGroupLeftSelectClassName, stickyRightClassName,
        stickyRightHeaderClassName, stickyGroupRightClassName,
        className,
      )}
      colSpan={colSpan}
      sortDirection={sortDirection}
      onClick={onClick}
    >
      {children}
    </TableCellInternal>
  );
}));

export default TableCell;
